import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'builder-panel-widths';

const DEFAULTS = {
  sidebar: 280,
  panel: 760,
};

export const usePanelResize = () => {
  const [widths, setWidths] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return DEFAULTS;
      const parsed = JSON.parse(stored);
      if (parsed.panel === 360) parsed.panel = DEFAULTS.panel;
      if (parsed.panel === 520) parsed.panel = 600;
      if (parsed.panel === 600) parsed.panel = DEFAULTS.panel;
      return { ...DEFAULTS, ...parsed };
    } catch {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(widths));
  }, [widths]);

  const setSidebarWidth = useCallback((w) => {
    setWidths((prev) => ({ ...prev, sidebar: Math.min(480, Math.max(200, w)) }));
  }, []);

  const setPanelWidth = useCallback((w) => {
    setWidths((prev) => ({ ...prev, panel: Math.min(800, Math.max(280, w)) }));
  }, []);

  return { widths, setSidebarWidth, setPanelWidth };
};

export default usePanelResize;
